var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Empty"},[_c('i',{staticClass:"el-icon-folder-opened"}),_c('span',[_vm._v(_vm._s((_vm.text && _vm.text.length>0)?_vm.text:'暂无数据'))])])}
var staticRenderFns = []

export { render, staticRenderFns }